import $ from 'jquery';

export function lockScreen(sMsg) {

	function removeLock() {
		clearTimeout($lockDiv.data("timer"));
		$lockDiv.remove();
	}

	var $lockDiv = $("#lockScreenDiv");
	if ($lockDiv.length > 0) {
		removeLock();
	}
	$lockDiv = $("<div/>").attr("id", "lockScreenDiv");
	$lockDiv.appendTo($("body"));


	if (sMsg) {
		var $msg = $("<div/>").addClass("message").html(sMsg);
		$msg.appendTo($lockDiv);
	}

	$lockDiv.on("click", function(e) { e.preventDefault(); });

	$lockDiv.data("timer", setTimeout(function() {
		var $b = $("<div/>").addClass("button").text("Remove lock");
		$b.on("click", function() { 
			removeLock();
		});
		$lockDiv.append($b);
	}, 5000));
	
	return {
		close : function() {
			removeLock();
		}
	};
}

export function navigate(url) {
	return function() { window.location.href = url; };
}

export function log(msg, deferred) {
	window.Bugsnag.notify(new Error(msg), {}, function() {
		if (deferred) {
			deferred.resolve();
		}
	});
}
